/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
/* eslint-disable react/prop-types */
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import { makeStyles } from '@mui/styles';
import {
	getLicenseInstallationsInfo,
	getLicenseStreamsheetsInfo,
	getLicenseValidUntil,
	getPremium,
	isPremiumLicense
} from '../../helper/license';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import { withUser } from '../../UserProvider';

const useStyles = makeStyles(() => ({
	tableContainer: {
		'& td:first-child': {
			width: '30%'
		}
	}
}));
export default withUser(({ licenseInfo }) => ({ licenseInfo }))(function License(props) {
	const classes = useStyles();
	const { licenseInfo } = props;

	const handleLicenseModify = () => {
		window.open('https://cedalo.com/pro-streamsheets/pricing/?product=streamsheets&premises=hosted&billing=annually&currency=eur&proSheets=10&busSheets=10', '_blank');
	};

	return (
		<div style={{ marginTop: '20px' }}>
			{licenseInfo && (
				<TableContainer className={classes.tableContainer}>
					<Table size="medium">
						<TableBody>
							<TableRow>
								<TableCell>
									<b>
										<FormattedMessage id="License.Edition" defaultMessage="Edition" />
									</b>
								</TableCell>
								<TableCell>
									{isPremiumLicense(licenseInfo) ? getPremium() : licenseInfo.edition}
								</TableCell>
							</TableRow>
							{isPremiumLicense(licenseInfo) && (
								<TableRow>
									<TableCell>
										<b>
											<FormattedMessage
												id="License.ValidUntil"
												defaultMessage="License valid until"
											/>
										</b>
									</TableCell>
									<TableCell>{getLicenseValidUntil(licenseInfo.daysLeft)}</TableCell>
								</TableRow>
							)}
							{isPremiumLicense(licenseInfo) && (
								<TableRow>
									<TableCell>
										<b>
											<FormattedMessage id="License.IssuedBy" defaultMessage="Issued by" />
										</b>
									</TableCell>
									<TableCell>{licenseInfo.issuedBy}</TableCell>
								</TableRow>
							)}
							{isPremiumLicense(licenseInfo) && (
								<TableRow>
									<TableCell>
										<b>
											<FormattedMessage id="License.IssuedTo" defaultMessage="Issued to" />
										</b>
									</TableCell>
									<TableCell>{licenseInfo.issuedTo}</TableCell>
								</TableRow>
							)}
							{isPremiumLicense(licenseInfo) && (
								<TableRow>
									<TableCell>
										<b>
											<FormattedMessage
												id="License.MaxInstallations"
												defaultMessage="Maximum installations"
											/>
										</b>
									</TableCell>
									<TableCell>{getLicenseInstallationsInfo(licenseInfo)}</TableCell>
								</TableRow>
							)}
							{isPremiumLicense(licenseInfo) && (
								<TableRow>
									<TableCell>
										<b>
											<FormattedMessage
												id="License.StreamsheetsMax"
												defaultMessage="Maximum number of Streamsheets"
											/>
										</b>
									</TableCell>
									<TableCell>{getLicenseStreamsheetsInfo(licenseInfo)}</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
			)}
			<Button sx={{ marginTop: '10px' }} variant="outlined" onClick={handleLicenseModify}>
				<FormattedMessage id="License.UpdateLicense" defaultMessage="View License Options" />
			</Button>
		</div>
	);
});
